import React from 'react';
import ReactApexChart from 'react-apexcharts';

const InvoiceLoadsPerDayChart = () => {
  const chartOptions = {
    series: [{
      name: 'Invoices',
      data: [
        1961310.07,
        2175736.26,
        2175736.26,
        449580.84,
        3650981.42,
        1234079.12,
        3403271.42
      ],
    }],
    options: {
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ['#5A05FF'],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 4,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          columnWidth: 24,
          dataLabels: {
            total: {
              enabled: false,
            },
          },
        },
      },
      xaxis: {
        categories: ['Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'],
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={chartOptions.options as any} series={chartOptions.series} type="bar" height={180} />
      </div>
    </div>
  );
}

function InvoiceLoadsByDay(): React.ReactElement {
  return (
    <InvoiceLoadsPerDayChart />
  );
}

export default InvoiceLoadsByDay;
